module.exports = __webpack_public_path__ + "static/media/products-4.a3091e1b.svg";